import Image, { StaticImageData } from 'next/image';
import { CSSProperties } from 'react';
import { useTheme } from 'styled-components';

export type ImagemProps = {
  imagemUrl: string | StaticImageData;
  style?: CSSProperties;
  descricaoImagem: string;
  priority: boolean;
  propsNextImage?: object;
};

export default function Imagem(props: ImagemProps) {
  const {
    imagemUrl,
    descricaoImagem,
    priority = true,
    style,
    propsNextImage = undefined,
  } = props;
  const theme = useTheme();

  return (
    <Image
      src={imagemUrl}
      alt={descricaoImagem}
      priority={priority}
      fill
      sizes={`${theme.spacing[2]}px`}
      style={{
        objectFit: 'cover',
        ...style,
      }}
      {...propsNextImage}
    />
  );
}
